/**
 * Logger utility that only logs in development mode
 * In production, all logs are silenced
 */

const isDevelopment = (() => {
  // Check if we're in a browser environment
  if (typeof window !== 'undefined') {
    // In browser: check hostname for local development
    const hostname = window.location.hostname
    const isLocalhost = 
      hostname === 'localhost' || 
      hostname === '127.0.0.1' || 
      hostname === '[::1]' ||
      hostname.startsWith('192.168.') ||
      hostname.startsWith('10.') ||
      hostname.endsWith('.local')
    
    // Also check for explicit dev mode flag (useful for staging environments)
    const isDevMode = typeof window !== 'undefined' && 
      (window as any).__DEV_MODE__ === true
    
    return isLocalhost || isDevMode
  }
  
  // Server-side: check NODE_ENV
  return process.env.NODE_ENV !== 'production'
})()

/**
 * Logger object with methods that match console API
 * In production, these are no-ops
 */
export const logger = {
  log: (...args: unknown[]) => {
    if (isDevelopment) {
      console.log(...args)
    }
  },
  
  error: (...args: unknown[]) => {
    if (isDevelopment) {
      console.error(...args)
    }
  },
  
  warn: (...args: unknown[]) => {
    if (isDevelopment) {
      console.warn(...args)
    }
  },
  
  info: (...args: unknown[]) => {
    if (isDevelopment) {
      console.info(...args)
    }
  },
  
  debug: (...args: unknown[]) => {
    if (isDevelopment) {
      console.debug(...args)
    }
  },
}

/**
 * Override console methods globally in production
 * Call this early in your app initialization (e.g., in layout.tsx or _app.tsx)
 * This ensures all console calls are silenced in production
 */
export function silenceConsoleInProduction() {
  if (!isDevelopment) {
    // Override console methods to be no-ops in production
    console.log = () => {}
    console.error = () => {}
    console.warn = () => {}
    console.info = () => {}
    console.debug = () => {}
  }
}

